import axios from "axios";
import { Loading, Message } from "element-ui";
import { saveAs } from "file-saver";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { blobValidate } from "@/utils/ruoyi";
import { apiUrl  } from "@/config";

const baseURL = apiUrl;
let downloadLoadingInstance;

function getMimeTypeFromExtension(ext) {
  const extensionMap = {
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    mp3: "audio/mpeg",
    wav: "audio/wav",
    mp4: "video/mp4",
    avi: "video/x-msvideo",
    wmv: "video/x-ms-wmv",
  };
  return extensionMap[ext] || "application/octet-stream";
}
export default {
async  name(name, type) {
    var url = baseURL + "/common/download?fileName=" + encodeURIComponent(name);
   await axios({
      method: "get",
      url: url,
      responseType: "blob",
      headers: { Authorization: "Bearer " + getToken() },
    }).then((res) => {
      let titType = '';
      if (res.headers["content-disposition"]) {
        // 使用正则表达式提取文件名
        const filenameMatch = res.headers["content-disposition"].match(/filename=([^;]+)/);

        if (filenameMatch && filenameMatch[1]) {
          const filename = filenameMatch[1];
          console.log("解析出的文件名:", filename);
          titType = filename
        } else {
          console.log("未找到文件名");
        }

      }

      const isBlob = blobValidate(res.data);
      if (isBlob) {
        const blob = new Blob([res.data]);
        this.saveAs(blob, titType || type);
      } else {
        this.printErrMsg(res.data);
      }
    });
  },
  async file(name, type = "") {
    var url = baseURL + "/common/download?fileName=" + encodeURIComponent(name);
    const res = await axios({
      method: "get",
      url: url,
      responseType: "blob",
      headers: { Authorization: "Bearer " + getToken() },
    })
    const isBlob = blobValidate(res.data);
    if (isBlob) {
      console.log();
      const blob = new Blob([res.data],);
      return blob;
    }

  },
  resource(resource) {
    var url =
      baseURL +
      "/common/download/resource?resource=" +
      encodeURIComponent(resource);
    axios({
      method: "get",
      url: url,
      responseType: "blob",
      headers: { Authorization: "Bearer " + getToken() },
    }).then((res) => {
      const isBlob = blobValidate(res.data);
      if (isBlob) {
        const blob = new Blob([res.data]);
        this.saveAs(blob, decodeURIComponent(res.headers["download-filename"]));
      } else {
        this.printErrMsg(res.data);
      }
    });
  },
  zip(url, name) {
    var url = baseURL + url;
    downloadLoadingInstance = Loading.service({
      text: "正在下载数据，请稍候",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    axios({
      method: "get",
      url: url,
      responseType: "blob",
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        const isBlob = blobValidate(res.data);
        if (isBlob) {
          const blob = new Blob([res.data], { type: "application/zip" });
          this.saveAs(blob, name);
        } else {
          this.printErrMsg(res.data);
        }
        downloadLoadingInstance.close();
      })
      .catch((r) => {
        console.error(r);
        Message.error("下载文件出现错误，请联系管理员！");
        downloadLoadingInstance.close();
      });
  },
  saveAs(text, name, opts) {
    saveAs(text, name, opts);
  },
  async printErrMsg(data) {
    const resText = await data.text();
    const rspObj = JSON.parse(resText);
    const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode["default"];
    Message.error(errMsg);
  },
};
